module.exports = __webpack_public_path__ + "static/img/p6-1.9bce7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p6-1.jpg
// module id = fr82
// module chunks = 1